import request from '@/router/axios';

const getList = (current, size, params) => request({
  url: '/api/mcc-staff/interview/page',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

const getMyList = (current, size, params) => request({
  url: '/api/mcc-staff/interview/headInterviewPage',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

const add = params => request({
  url: '/api/mcc-staff/interview/save',
  method: 'post',
  data: params,
})

const detail = params => request({
  url: '/api/mcc-staff/interview/detail',
  method: 'get',
  params: {
    ...params,
  },
})

const edit = params => request({
  url: '/api/mcc-staff/interview/update',
  method: 'post',
  data: params,
})

const editOrganization = params => request({
  url: '/api/mcc-staff/interview/update',
  method: 'post',
  data: params,
})

const editStatus = params => request({
  url: '/api/mcc-staff/interview/updateStatus',
  method: 'post',
  data: params,
})

const remove = ids => request({
  url: '/api/mcc-staff/interview/remove',
  method: 'post',
  params: {
    ids,
  },
})

const over = params => request({
  url: '/api/mcc-staff/interview/over',
  method: 'post',
  data: params,
})

const audit = (params, headers) => request({
  url: '/api/mcc-staff/interview/approval',
  method: 'post',
  headers,
  params: {
    ...params,
  },
})

const sendOffer = params => request({
  url: '/api/mcc-staff/offer/send',
  method: 'post',
  params: {
    ...params,
  },
})

const sendContract = params => request({
  url: '/api/mcc-staff/recruitmentcontract/send',
  method: 'post',
  params: {
    ...params,
  },
})

const reInterview = params => request({
  url: '/api/mcc-staff/interview/again',
  method: 'post',
  params: {
    ...params,
  },
})

const isPass = params => request({
  url: '/api/mcc-staff/interview/submitResult ',
  method: 'post',
  data: params,
})

const isPass2 = params => request({
  url: '/api/mcc-staff/interview/submitResultHOD ',
  method: 'post',
  data: params,
})

const resultEmail = params => request({
  url: '/api/mcc-staff/interview/resultEmail ',
  method: 'post',
  data: params,
})

const leaderApproval = (params, headers = {}) => request({
  url: '/api/mcc-staff/interview/leaderApproval2',
  method: 'post',
  headers,
  data: {
    ...params,
  },
})

const downloadOffer = params => request({
  url: '/api/mcc-staff/offer/detail',
  method: 'get',
  params: {
    ...params,
  },
})

const getInterviewProcess = params => request({
  url: '/api/mcc-staff/interview/interviewProcess',
  method: 'get',
  params: {
    ...params,
  },
})

const getLeaderInterviewProcess = params => request({
  url: '/api/mcc-staff/interview/leaderInterviewProcess',
  method: 'get',
  params: {
    ...params,
  },
})

const interviewinfoDetail = params => request({
  url: '/api/mcc-staff/interviewinfo/detail',
  method: 'get',
  params: {
    ...params,
  },
})

const interviewresult = params => request({
  url: '/api/mcc-staff/interviewresult/map',
  method: 'get',
  params: {
    ...params,
  },
})

const editOffer = params => request({
  url: '/api/mcc-staff/offer/generate',
  method: 'post',
  data: params,
})

const editContract = params => request({
  url: '/api/mcc-staff/recruitmentcontract/generate',
  method: 'post',
  data: params,
})

const leaderInterviewDetail = params => request({
  url: '/api/mcc-staff/interview/leaderInterviewDetail',
  method: 'get',
  params: {
    ...params,
  },
})
const contractDetail = params => request({
  url: '/api/mcc-staff/recruitmentcontract/contractDetail',
  method: 'get',
  params: {
    ...params,
  },
})

const exportExcel = params => request({
  url: '/api/mcc-staff/interview/excel',
  method: 'get',
  responseType: 'blob',
  params: {
    ...params,
  },
})

const statisticsOnboarding = params => request({
  url: '/api/mcc-staff/interview/statisticsOnboarding',
  method: 'get',
  params: {
    ...params,
  },
})
const getOnboarding = params => request({
  url: '/api/mcc-staff/interview/getOnboarding',
  method: 'get',
  params: {
    ...params,
  },
})

export const getOnboardingCalendar = params => request({
  url: '/api/mcc-staff/interview/getOnboardingCalendar',
  method: 'get',
  params: {
    ...params,
  },
})
export default {
  getList,
  add,
  detail,
  edit,
  remove,
  over,
  audit,
  sendOffer,
  reInterview,
  isPass,
  downloadOffer,
  getInterviewProcess,
  getLeaderInterviewProcess,
  interviewinfoDetail,
  interviewresult,
  leaderApproval,
  editOffer,
  getMyList,
  resultEmail,
  leaderInterviewDetail,
  exportExcel,
  editContract,
  sendContract,
  contractDetail,
  editOrganization,
  editStatus,
  statisticsOnboarding,
  getOnboarding,
  getOnboardingCalendar,
  isPass2
};
